/*jslint browser: true, todo: true, -W117, sloppy: true */
var windowHeight,
    windowWidth,
    documentHeight,
    mainContent,
    footerHeight,
    scroll_y;

function resizeContent() {
    'use strict';

    windowHeight = $(window).height();
    windowWidth = $(window).width();
    documentHeight = $(document).height();
    footerHeight = $('#footer-wrapper').outerHeight();
    // mainContent = windowHeight - navHeight;

    $('#main-slide').css('height', windowHeight);
    $('#content-wrapper').css('margin-bottom', footerHeight );
}

function parallax() {
    if  ( (documentHeight - windowHeight) - scroll_y < footerHeight ){
        $('#footer-wrapper').css({zIndex: 4});
    } else {
        $('#footer-wrapper').css({zIndex: 1});
    }
}

function isMobile() {
    var ua = navigator.userAgent,
    device = ua.match(/GoogleTV|SmartTV|Internet.TV|NetCast|NETTV|AppleTV|boxee|Kylo|Roku|DLNADOC|CE\-HTML/i) ? 3 : ua.match(/Xbox|PLAYSTATION.3|Wii/i) ? 3 : ua.match(/iP(a|o)d/i) || ua.match(/tablet/i) && !ua.match(/RX-34/i) || ua.match(/FOLIO/i) ? 2 : ua.match(/Linux/i) && ua.match(/Android/i) && !ua.match(/Fennec|mobi|HTC.Magic|HTCX06HT|Nexus.One|SC-02B|fone.945/i) ? 2 : ua.match(/Kindle/i) || ua.match(/Mac.OS/i) && ua.match(/Silk/i) ? 2 : ua.match(/GT-P10|SC-01C|SHW-M180S|SGH-T849|SCH-I800|SHW-M180L|SPH-P100|SGH-I987|zt180|HTC(.Flyer|\_Flyer)|Sprint.ATP51|ViewPad7|pandigital(sprnova|nova)|Ideos.S7|Dell.Streak.7|Advent.Vega|A101IT|A70BHT|MID7015|Next2|nook/i) || ua.match(/MB511/i) && ua.match(/RUTEM/i) ? 2 : ua.match(/BOLT|Fennec|Iris|Maemo|Minimo|Mobi|mowser|NetFront|Novarra|Prism|RX-34|Skyfire|Tear|XV6875|XV6975|Google.Wireless.Transcoder/i) ? 1 : ua.match(/Opera/i) && ua.match(/Windows.NT.5/i) && ua.match(/HTC|Xda|Mini|Vario|SAMSUNG\-GT\-i8000|SAMSUNG\-SGH\-i9/i) ? 1 : ua.match(/Windows.(NT|XP|ME|9)/) && !ua.match(/Phone/i) || ua.match(/Win(9|.9|NT)/i) ? 0 : ua.match(/Macintosh|PowerPC/i) && !ua.match(/Silk/i) ? 0 : ua.match(/Linux/i) && ua.match(/X11/i) ? 0 : ua.match(/Solaris|SunOS|BSD/i) ? 0 : ua.match(/Bot|Crawler|Spider|Yahoo|ia_archiver|Covario-IDS|findlinks|DataparkSearch|larbin|Mediapartners-Google|NG-Search|Snappy|Teoma|Jeeves|TinEye/i) && !ua.match(/Mobile/i) ? 0 : 1;
    return device;
}

$(document).ready(function($){
'use strict';

    resizeContent();
    $(window).resize(function() {
        resizeContent();
    });

});

/*-----------------------------------------------------------------------------------*/
/*  PARALLAX EFFECT'S
/*-----------------------------------------------------------------------------------*/
$(window).scroll(function() {
'use strict';
    /*** footer ***/
    resizeContent();

});

/*-----------------------------------------------------------------------------------*/
/*  PRELOADER
/*-----------------------------------------------------------------------------------*/

$(document).ready(function($){
'use strict';
    $(window).on('load', function(){
        $('.loader').fadeOut('slow',function(){
            $(this).remove();
            $('body').trigger( "loaded");
        });

        if(window.location.hash == '#autoplay' && document.querySelector('#video-autoplay')) {
            document.querySelector('#video-autoplay').click();
        }
    });
});
